"use client"
import { motion } from "motion/react"
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion"
import { SectionTitle } from "@/components/ui/section-title"

export default function FAQ() {
    return (
        <section id="faq" className="wrapper py-medium overflow-hidden">
            <div className="flex flex-col w-full max-w-screen-2xl">

                {/* Header */}
                <div className="flex flex-col items-center gap-3 mb-12 text-center">
                    <SectionTitle theme="dark">
                        Frequently Asked Questions
                    </SectionTitle>

                    <motion.h2
                        className="text-h2 text-balance max-w-3xl text-center"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{
                            opacity: 1,
                            y: 0,
                            transition: { duration: 0.3, delay: 0.1 }
                        }}
                    >
                        Everything You Need to Know About Selling Your Watch
                    </motion.h2>

                    <motion.p
                        className="text-large text-muted-foreground max-w-2xl text-balance text-center"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{
                            opacity: 1,
                            y: 0,
                            transition: { duration: 0.3, delay: 0.2 }
                        }}
                    >
                        Have questions about our process? Find answers to the most common questions about selling luxury watches.
                    </motion.p>
                </div>

                {/* FAQ Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12">

                    {/* Left Column */}
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{
                            opacity: 1,
                            x: 0,
                            transition: { duration: 0.4, delay: 0.3 }
                        }}
                    >
                        <Accordion type="single" collapsible className="w-full space-y-0">
                            {leftColumnFAQs.map((faq, index) => (
                                <AccordionItem key={index} value={`left-${index}`} className="border-b border-border/50 last:border-b-0">
                                    <AccordionTrigger className="text-left">
                                        {faq.question}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-muted-foreground leading-relaxed">
                                        {faq.answer}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </motion.div>

                    {/* Right Column */}
                    <motion.div
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{
                            opacity: 1,
                            x: 0,
                            transition: { duration: 0.4, delay: 0.4 }
                        }}
                    >
                        <Accordion type="single" collapsible className="w-full space-y-0">
                            {rightColumnFAQs.map((faq, index) => (
                                <AccordionItem key={index} value={`right-${index}`} className="border-b border-border/50 last:border-b-0">
                                    <AccordionTrigger className="text-left">
                                        {faq.question}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-muted-foreground leading-relaxed">
                                        {faq.answer}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </motion.div>
                </div>



            </div>
        </section>
    )
}

const leftColumnFAQs = [
    {
        question: "How do you determine the value of my watch?",
        answer: "Our certified experts assess your watch based on brand, model, condition, age, rarity, and current market demand. We use industry-standard valuation methods and real-time market data to provide accurate pricing."
    },
    {
        question: "Is there a fee for getting my watch appraised?",
        answer: "No, our initial appraisal and quote are completely free with no obligation. "
    },
    {
        question: "How long does the entire process take?",
        answer: "From initial contact to payment, the process typically takes 3-5 business days. We provide a preliminary quote within 24 hours, and final payment is made the same day you accept our offer."
    },
    {
        question: "What condition does my watch need to be in?",
        answer: "We purchase watches in all conditions - from pristine to needing repair. The condition affects the price, but we're interested in luxury timepieces regardless of their current state."
    },

];

const rightColumnFAQs = [
    {
        question: "What brands do you purchase?",
        answer: "We purchase all major luxury watch brands including Rolex, Patek Philippe, Audemars Piguet, Omega, Cartier, Breitling, TAG Heuer, and many others. Contact us about any luxury timepiece."
    },
    {
        question: "Do you buy vintage or antique watches?",
        answer: "Yes, we specialize in vintage and antique luxury watches. These often have unique value due to their rarity and historical significance. Our experts have extensive knowledge of vintage timepieces."
    },
    /*
    {
        question: "How do you ensure secure shipping?",
        answer: "We provide fully insured shipping labels with tracking. All packages are covered for the full appraised value during transit. We also offer in-person appointments at our secure office - One Canada Square, Canary Wharf."
    },*/
    {
        question: "What payment methods do you offer?",
        answer: "We offer bank transfer or cash payment. All payments are processed the same day you accept our final offer, with no hidden fees or delays."
    },


];
